<template>
  <!-- Fleet Type -->
  <b-tab class="border-0">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('setting.list.managementAsset.gps.move') }}</span>
    </template>

    <!-- Table -->
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :hasCheckbox="false"
      :searchable="true"
      :hasBilingual="true"
    >
      <template #cell(activeOn)="data">
        {{ data.item ? momentDateShortMonth(data.item.activeOn) : '-' }}<br />
        <span class="text-muted" v-if="data.item.activeOn">{{
          data.item ? momentTimeSeconds(data.item.activeOn) : '-'
        }}</span>
      </template>
      <template #cell(inactiveOn)="data">
        {{ data.item ? momentDateShortMonth(data.item.inactiveOn) : '-' }}<br />
        <span class="text-muted" v-if="data.item.inactiveOn">{{
          data.item ? momentTimeSeconds(data.item.inactiveOn) : '-'
        }}</span>
      </template>
    </McGrapqlTable>
  </b-tab>
</template>

<script>
import { Helper } from '@/mixin/helper'
import McGrapqlTable from '@/components/McGrapqlTable'

import { GET_MOVING_HISTORY } from '@/services/api/setting/personalization/gps'

export default {
  components: {
    McGrapqlTable,
  },
  props: {
    item: {
      required: true,
    },
  },
  mixins: [Helper],
  data() {
    return {
      data: [],
      imei: this.$route.params.imei,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'company.name',
          label: this.$t('setting.list.managementAsset.gps.companyName'),
          isSortable: false,
          isLocked: false,
        },
        {
          key: 'licensePlate',
          label: this.$t('setting.list.managementAsset.gps.licensePlate'),
          isSortable: false,
          isLocked: false,
        },
        {
          key: 'phoneNo',
          label: this.$t('setting.list.managementAsset.gps.phoneNo'),
          isSortable: false,
          isLocked: false,
        },
        {
          key: 'activeOn',
          label: this.$t('setting.list.managementAsset.gps.activeOn'),
          isSortable: true,
          isLocked: false,
        },
        {
          key: 'inactiveOn',
          label: this.$t('setting.list.managementAsset.gps.inactiveOn'),
          isSortable: true,
          isLocked: false,
        },
      ]
    },
    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_MOVING_HISTORY,
            variables: {
              filter: { ...filter, imei: this.imei },
            },
          })
          const self = this
          const result = res.data.deviceHistoriesPaginated.deviceHistoriesPaginated
          self.data = result.data
          return result
        },
      }
    },
  },
}
</script>
